export default {
  data() {
    return {
      /**
       * {
       *   id: string,
       *   handler: function
       * }
       */
      targetCDEvents: [],
    };
  },
  mounted() {
    this.listenCDEvents(this.targetCDEvents);
  },
  beforeDestroy() {
    this.destroyCDEvents(this.targetCDEvents);
  },
  methods: {
    listenCDEvents(targetCDEvents) {
      targetCDEvents.forEach((event) => {
        window.CDEventBus.$on(event.id, event.handler);
      });
    },
    destroyCDEvents(targetCDEvents) {
      targetCDEvents.forEach((event) => {
        window.CDEventBus.$off(event.id);
      });
    },
    getEventEmitId(eventId, payload = {}) {
      return `CDEventBus.emit('${eventId}', ${JSON.stringify(payload).replaceAll('"', '&quot;')})`;
    },
  },
}
